import { ArrowCcwIcon } from "@xola/icons";
import { Button, FormGroup, Input } from "@xola/ui-kit";
import React from "react";
import { ColorResult, CustomPicker } from "react-color";
import { Hue, Saturation } from "react-color/lib/components/common";

interface ColorPickerProps {
    color: string;
    isLoading: boolean;
    onChange: (color: ColorResult) => void;
    onInputChange: (color: { hex: string }) => void;
    onUpdate: () => void;
    onReset: () => void;
}

const ColorPicker = ({ color, onInputChange, onChange, onUpdate, onReset, isLoading, ...rest }: ColorPickerProps) => {
    return (
        <div className="flex flex-col space-y-4 rounded border border-gray-light p-4">
            <div className="flex space-x-4">
                <div className="relative h-80 w-72 cursor-crosshair overflow-hidden">
                    <Saturation
                        {...rest}
                        // @ts-expect-error The @types/react-color package doesn't seem to be up to date
                        radius={5}
                        pointer={() => <BlockPointer color={color} />}
                        onChange={onChange}
                    />
                </div>
                <div className="relative h-80 w-2">
                    <Hue
                        {...rest}
                        // @ts-expect-error The @types/react-color package doesn't seem to be up to date
                        radius={5}
                        pointer={() => <HuePointer color={color} />}
                        direction="vertical"
                        onChange={onChange}
                    />
                </div>
            </div>
            <div>
                <div className="flex w-full justify-between space-x-2 pr-5">
                    <FormGroup className="mb-1 flex items-center space-x-1">
                        <div className="h-9 w-9 rounded" style={{ backgroundColor: color }} />
                        <div className="w-25">
                            <Input
                                value={color}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                    onInputChange({ hex: e.target.value })
                                }
                            />
                        </div>
                    </FormGroup>
                    <Button disabled={!/^#+([a-fA-F\d]{6}|[a-fA-F\d]{3})$/.test(color) || isLoading} onClick={onUpdate}>
                        Update
                    </Button>
                </div>
                <div className="flex items-center space-x-1">
                    <ArrowCcwIcon className="top-0 text-primary" />
                    <div className="cursor-pointer text-primary underline underline-offset-2" onClick={onReset}>
                        Reset to default
                    </div>
                </div>
            </div>
        </div>
    );
};

interface PointerProps {
    color: string;
}

const BlockPointer = ({ color }: PointerProps) => (
    <div
        className="absolute -left-2.5 -top-2.5 h-4 w-4 rounded-full border-2 border-white"
        style={{ backgroundColor: color }}
    />
);

const HuePointer = ({ color }: PointerProps) => (
    <div
        className="absolute -left-1.5 -top-1.5 h-2.5 w-5 rounded-full border-2 border-white drop-shadow-md"
        style={{ backgroundColor: color }}
    />
);

// eslint-disable-next-line new-cap
export default CustomPicker(ColorPicker);
